import React, { ReactElement } from 'react';

export { default as compose } from './core/compose';
export { default as curry } from './core/curry';
export { default as type } from './core/type';
export { default as getSymbolByCurrencyCode } from './core/symbol';

export { default as bimap } from './pointfree/bimap';
export { default as concat } from './pointfree/concat';
export { default as filter } from './pointfree/filter';
export { default as map } from './pointfree/map';
export { default as mapPropNames } from './pointfree/mapPropNames';
export { default as reduce } from './pointfree/reduce';

export { isAfterReconnect, reconnectMark } from './predicates/isAfterReconnect';
export { default as isArray } from './predicates/isArray';
export { default as isDefined } from './predicates/isDefined';
export { default as isEmpty } from './predicates/isEmpty';
export { default as isFunction } from './predicates/isFunction';
export { default as isInteger } from './predicates/isInteger';
export { default as isNil } from './predicates/isNil';
export { default as isNumber } from './predicates/isNumber';
export { default as isObject } from './predicates/isObject';
export { default as isPromise } from './predicates/isPromise';
export { default as isSameType } from './predicates/isSameType';
export { default as isString } from './predicates/isString';
export { default as isUrl } from './predicates/isUrl';
export { default as isIframe } from './predicates/isIframe';
export { default as isPopup } from './predicates/isPopup';
export { default as isFullscreen } from './predicates/isFullscreen';

export { default as clamp } from './helpers/clamp';
export { default as hex2rgba } from './helpers/hex2rgba';
export { default as is } from './helpers/is';
export { default as shallowEqual } from './helpers/shallowEqual';
export { default as ls } from './helpers/localstorage';
export { default as ss } from './helpers/sessionstorage';
export { default as parseJson } from './helpers/parseJson';

export { getDevice } from './helpers/getDevice';
export { getPlatform } from './helpers/getPlatform';
export { getBrowser } from './helpers/getBrowser';
export { getFrame } from './helpers/getFrame';
export { getOrientation } from './helpers/getOrientation';
export { getGameId } from './helpers/getGameId';
export { calcDownloadedSize } from './helpers/calcDownloadedSize';
export { getSanitizedTimestamp } from './helpers/getSanitizedTimestamp';
export { buildQueryFromObject } from './helpers/buildQueryFromObject';
export { getAuthEndpointForExternalIntegration } from './helpers/getAuthEndpointForExternalIntegration';
export { namedImport } from './helpers/namedImport';
export { useLogDevicePerformance } from './performance/devicePerformance/useLogDevicePerformance';
export { getCountryCode } from './helpers/getCountryCode';
export * from './performance/proxyDetection';
export { NetworkPerformanceTracker } from './performance/networkPerformanceTracker';
export { getUDSideBetLabel } from './helpers/getUDSideBetLabel';

export { Numeric } from './numeric';

export { api } from './http/httpRequest';
export { handleError } from './http/httpErrors';
export * from './http/errors';

export { DeviceInfo } from './helpers/deviceInfo';

export * from './functions';

// eslint-disable-next-line max-len
export const componentOverride = (Component: ReactElement) => () => Promise.resolve({ default: (props: any) => React.cloneElement(Component, props) });

export const noComponentOverride = () => Promise.resolve({ default: () => null });

export const noComponent = () => null;
